// src/components/Dashboard/DashboardForm.js
import React from "react";
import {
  Box,
  Heading,
  SimpleGrid,
  Card,
  CardHeader,
  CardBody,
  Text,
  LinkBox,
  LinkOverlay,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

const dashboardLinks = [
  { title: "Learning Dashboard", description: "Switch between training modules", path: "/dashboard/learning" },
  { title: "Payments Dashboard", description: "Manage invoices, payments, and subscriptions", path: "/payments/overview" },
  { title: "Job Dashboard", description: "Manage job postings and applications", path: "/jobs/dashboard" },
];

const DashboardForm = () => {
  return (
    <Box p={6}>
      <Heading mb={6} textAlign="center">
        Admin Dashboard
      </Heading>
      <SimpleGrid columns={[1, 2, 3]} spacing={6}>
        {dashboardLinks.map((link) => (
          <LinkBox
            as="article"
            key={link.title}
            borderWidth="1px"
            borderRadius="lg"
            shadow="md"
            p={4}
            _hover={{
              shadow: "lg",
              transform: "scale(1.02)",
              bg: "gray.50",
            }}
            transition="all 0.2s"
          >
            <Card border="none" shadow="none">
              <CardHeader pb={2}>
                <Heading size="md">
                  <LinkOverlay as={Link} to={link.path}>
                    {link.title}
                  </LinkOverlay>
                </Heading>
              </CardHeader>
              <CardBody pt={0}>
                <Text>{link.description}</Text>
              </CardBody>
            </Card>
          </LinkBox>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default DashboardForm;
